import { useLayoutEffect } from 'react'

export function useForceLightMode() {
  useLayoutEffect(() => {
    const html = document.documentElement
    const wasDark = html.classList.contains('dark')
    html.classList.remove('dark')
    html.style.colorScheme = 'light'
    return () => {
      if (wasDark) {
        html.classList.add('dark')
        html.style.colorScheme = 'dark'
      }
    }
  }, [])
}
